import { HREF_LANG_LOCALE, DEFAULT_LOCALE } from './consts.js'

export function generateHrefLangsForCurrentRoute () {
  const href = window.location.href.split('?')[0]

  return HREF_LANG_LOCALE.map(locale => ({
    rel: 'alternate',
    hreflang: locale,
    href: href.replace(/\/[a-z]{2}-[a-z]{2}\//i, `/${locale === 'x-default' ? DEFAULT_LOCALE : locale}/`),
  }))
}
